module.exports = __webpack_public_path__ + "img/computer.e75149de.png";